import React, { FC } from 'react';

export const IconAvailableForPurchase: FC<React.PropsWithChildren<{ className?: string }>> = ({ className }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M7.00098 10C7.55304 10.0003 8.00098 10.4479 8.00098 11L8 17C7.99974 17.5521 7.55212 18 7 18H1C0.73496 17.9999 0.48039 17.8945 0.292969 17.707C0.105548 17.5196 0.000129383 17.265 0 17L0.000976562 11C0.00097662 10.4477 0.448692 10 1.00098 10H7.00098ZM2 16H6.00098V12H2.00098L2 16Z"
      fill="#101010"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M7.10254 0.00488281C7.60667 0.0562146 8 0.482323 8 1V7C7.99974 7.55206 7.55212 8 7 8H1C0.73496 7.99987 0.48039 7.89445 0.292969 7.70703C0.105548 7.51961 0.000129384 7.26504 0 7V0.999023C0.000263648 0.447126 0.448102 0.000263327 1 0H7L7.10254 0.00488281ZM2 6H6V2H2V6Z"
      fill="#101010"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M17.0005 0C17.5525 0.00026392 18.0005 0.447878 18.0005 1V7C18.0002 7.5519 17.5524 7.99974 17.0005 8H10.9995C10.7347 7.99987 10.4808 7.89415 10.2935 7.70703C10.106 7.51961 10.0006 7.26504 10.0005 7V0.999023C10.0008 0.446963 10.4484 2.81778e-07 11.0005 0H17.0005ZM12.0005 6H16.0005V2H12.0005V6Z"
      fill="#101010"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M17.0015 10C17.5535 10.0003 18.0015 10.4479 18.0015 11L18.0005 17C18.0002 17.5521 17.5526 18 17.0005 18H11.0005C10.7354 17.9999 10.4809 17.8945 10.2935 17.707C10.106 17.5196 10.0006 17.265 10.0005 17L10.0015 11C10.0015 10.4477 10.4492 10 11.0015 10H17.0015ZM12.0005 16H16.0015V12H12.0015L12.0005 16Z"
      fill="#101010"
    />
  </svg>
);
